export default "__VITE_ASSET__4a6f4e94__"